import React, { useEffect, useState } from "react";
import { Alert, Card, CardContent, Stack, Typography } from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { Link } from "react-router-dom";

import { listNetworkPortalAssignments } from "../../services/coreNetworkPortal";
import {
  NetworkPortalLayout,
  PortalAuthState,
  PortalLoading,
  StatusChip,
  TalentPortalEmptyState,
  formatDateTime,
  safeArray,
  toTitleCase,
  useNetworkPortalSession,
} from "./networkPortalShared";

export default function NetworkPortalAssignmentList() {
  const { member, loading, error } = useNetworkPortalSession();
  const [assignments, setAssignments] = useState([]);
  const [pageError, setPageError] = useState("");

  useEffect(() => {
    if (!member) return;
    let active = true;

    async function loadAssignments() {
      try {
        setPageError("");
        const response = await listNetworkPortalAssignments();
        if (active) {
          setAssignments(safeArray(response.assignments));
        }
      } catch (loadError) {
        if (active) {
          setPageError(loadError?.response?.data?.message || loadError.message || "Unable to load assignments.");
        }
      }
    }

    loadAssignments();
    return () => {
      active = false;
    };
  }, [member]);

  if (loading) return <PortalLoading />;
  if (!member) return <PortalAuthState error={error} />;

  return (
    <NetworkPortalLayout title="Assignments" subtitle="Work that has been assigned to your Core Network profile." member={member}>
      <Stack spacing={2.5}>
        {pageError ? <Alert severity="error">{pageError}</Alert> : null}
        {assignments.length ? assignments.map((assignment) => (
          <Card key={assignment.id} component={Link} to={`/talent/assignments/${assignment.id}`} elevation={0} sx={{ border: "1px solid #d9e2ec", borderRadius: 3, textDecoration: "none", color: "inherit" }}>
            <CardContent>
              <Stack spacing={1}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {assignment.workRequest?.title || `Assignment #${assignment.id}`}
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                  <StatusChip value={assignment.status} />
                  <StatusChip value={assignment.workRequest?.priority} />
                  <Typography variant="caption" color="text.secondary">{toTitleCase(assignment.workRequest?.requestType)}</Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  Due {formatDateTime(assignment.workRequest?.deadlineAt)} | Updated {formatDateTime(assignment.updatedAt)}
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        )) : (
          <TalentPortalEmptyState icon={<AssignmentTurnedInIcon fontSize="small" />} title="No assignments yet" description="No assignments have been shared with you yet." />
        )}
      </Stack>
    </NetworkPortalLayout>
  );
}
